import { Box } from '@mui/material'
import { LoadingPicture } from '../shared/LoadingPicture'
import { NavBar } from './Navigation'

export function March2019() {
  const isMobile = window.innerWidth < 768

  return (
    <Box>
      <Box sx={{ padding: '10px' }}>
        <NavBar direction="row" />
      </Box>

      {isMobile ? (
        <Box sx={{ padding: '0 40px' }}>
          <LoadingPicture
            imageId="2019_wedding_steps.jpg"
            size="medium"
            stage="prod"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              marginBottom: '40px',
            }}
          />
          <LoadingPicture
            imageId="2019_wedding_minis.jpg"
            size="medium"
            stage="prod"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              alignContent: 'center',
              marginBottom: '40px',
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            padding: '0 150px',
            gap: '10%',
          }}
        >
          <LoadingPicture
            imageId="2019_wedding_steps.jpg"
            size="medium"
            stage="prod"
            style={{
              width: '50%',
              height: 'auto',
              objectFit: 'cover',
              flexShrink: 0,
            }}
          />
          <LoadingPicture
            imageId="2019_wedding_minis.jpg"
            size="medium"
            stage="prod"
            style={{
              width: '50%',
              height: 'auto',
              objectFit: 'cover',
              //   marginLeft: '-10%',
              alignContent: 'center',
              flexShrink: 0,
            }}
          />
        </Box>
      )}
    </Box>
  )
}
